import React, { useContext } from 'react';
import { observer } from 'mobx-react-lite';
import { pxToRem } from 'choerodon-ui/lib/_util/UnitConvertor';
import measureScrollbar from 'choerodon-ui/lib/_util/measureScrollbar';
import TableContext from './TableContext';
import { ColumnLock } from './enum';
const TableBody = function TableBody(props) {
    const { children, lock, onScroll, style, getRef } = props;
    const { prefixCls, tableStore } = useContext(TableContext);
    const { hasFooter, overflowY, overflowX, height } = tableStore;
    const fixedLeft = lock === true || lock === ColumnLock.left;
    const scrollbar = measureScrollbar();
    const hasFooterAndNotLock = !lock && hasFooter && overflowX && scrollbar;
    const hasLockAndNoFooter = lock && !hasFooter && overflowX && height !== undefined && scrollbar;
    const tableBody = (React.createElement("div", { ref: getRef, className: `${prefixCls}-body`, style: {
            ...(height === undefined ? style : {}),
            height: pxToRem(hasFooterAndNotLock && height !== undefined ? height + scrollbar : hasLockAndNoFooter && height !== undefined ? height - scrollbar : height),
            marginBottom: hasFooterAndNotLock ? pxToRem(-scrollbar) : undefined,
            width: fixedLeft ? pxToRem(tableStore.leftColumnGroups.width + (scrollbar || 20)) :
                lock === ColumnLock.right
                    ? pxToRem(tableStore.rightColumnGroups.width - 1 + (overflowY ? scrollbar : 0))
                    : undefined,
            marginLeft: lock === ColumnLock.right ? pxToRem(1) : undefined,
        }, onScroll: onScroll }, children));
    if (fixedLeft) {
        return (React.createElement("div", { className: `${prefixCls}-body-wrapper`, style: { width: pxToRem(tableStore.leftColumnGroups.width) } }, tableBody));
    }
    return tableBody;
};
TableBody.displayName = 'TableBody';
export default observer(TableBody);
